/**
 * Утилита для работы с тактильными вибрациями в Telegram WebApp
 */

/**
 * Типы вибраций для различных действий
 */
export const HapticType = {
  LIGHT: 'light',
  MEDIUM: 'medium',
  HEAVY: 'heavy',
  RIGID: 'rigid',
  SOFT: 'soft',
};

/**
 * Типы уведомлений
 */
export const NotificationType = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
};

/**
 * Проверка доступности Haptic Feedback API
 */
export const isHapticAvailable = () => {
  return !!(window.Telegram?.WebApp?.HapticFeedback);
};

/**
 * Базовая вибрация при взаимодействии
 * @param {string} style - Стиль вибрации (light, medium, heavy, rigid, soft)
 */
export const hapticImpact = (style = HapticType.LIGHT) => {
  if (isHapticAvailable()) {
    try {
      window.Telegram.WebApp.HapticFeedback.impactOccurred(style);
    } catch (error) {
      console.warn('Haptic feedback error:', error);
    }
  }
};

/**
 * Вибрация для уведомлений
 * @param {string} type - Тип уведомления (error, success, warning)
 */
export const hapticNotification = (type = NotificationType.SUCCESS) => {
  if (isHapticAvailable()) {
    try {
      window.Telegram.WebApp.HapticFeedback.notificationOccurred(type);
    } catch (error) {
      console.warn('Haptic feedback error:', error);
    }
  }
};

/**
 * Вибрация при изменении выбора
 */
export const hapticSelection = () => {
  if (isHapticAvailable()) {
    try {
      window.Telegram.WebApp.HapticFeedback.selectionChanged();
    } catch (error) {
      console.warn('Haptic feedback error:', error);
    }
  }
};

/**
 * Предустановленные комбинации вибраций для частых действий
 */
export const HapticPresets = {
  // Легкое нажатие на обычную кнопку
  buttonPress: () => hapticImpact(HapticType.LIGHT),
  
  // Нажатие на важную кнопку
  buttonPressImportant: () => hapticImpact(HapticType.MEDIUM),
  
  // Нажатие на критичную кнопку (удаление, подтверждение)
  buttonPressCritical: () => hapticImpact(HapticType.HEAVY),
  
  // Переключение чекбокса или свитча
  toggle: () => hapticSelection(),
  
  // Открытие/закрытие модального окна
  modalOpen: () => hapticImpact(HapticType.SOFT),
  modalClose: () => hapticImpact(HapticType.SOFT),
  
  // Успешное действие
  success: () => hapticNotification(NotificationType.SUCCESS),
  
  // Ошибка
  error: () => hapticNotification(NotificationType.ERROR),
  
  // Предупреждение
  warning: () => hapticNotification(NotificationType.WARNING),
  
  // Навигация
  navigation: () => hapticImpact(HapticType.LIGHT),
  
  // Загрузка файла
  fileUpload: () => hapticImpact(HapticType.MEDIUM),
  
  // Удаление
  delete: () => hapticImpact(HapticType.HEAVY),
  
  // Выбор элемента из списка
  itemSelect: () => hapticSelection(),
  
  // Размещение печати на документе
  stampPlace: () => hapticImpact(HapticType.MEDIUM),
  
  // Подписание документа
  documentSign: () => {
    hapticImpact(HapticType.HEAVY);
    setTimeout(() => hapticNotification(NotificationType.SUCCESS), 200);
  },
};

/**
 * Обертка для добавления haptic feedback к обработчику события
 * @param {Function} handler - Оригинальный обработчик
 * @param {string} hapticType - Тип вибрации
 * @returns {Function} - Новый обработчик с вибрацией
 */
export const withHaptic = (handler, hapticType = HapticType.LIGHT) => {
  return (...args) => {
    hapticImpact(hapticType);
    if (handler) {
      return handler(...args);
    }
  };
};

/**
 * Обертка для добавления preset вибрации к обработчику
 * @param {Function} handler - Оригинальный обработчик
 * @param {Function} hapticPreset - Preset вибрации
 * @returns {Function} - Новый обработчик с вибрацией
 */
export const withHapticPreset = (handler, hapticPreset) => {
  return (...args) => {
    if (hapticPreset) {
      hapticPreset();
    }
    if (handler) {
      return handler(...args);
    }
  };
};

export default {
  HapticType,
  NotificationType,
  isHapticAvailable,
  hapticImpact,
  hapticNotification,
  hapticSelection,
  HapticPresets,
  withHaptic,
  withHapticPreset,
};







